// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"121":"8e51f9e8","759":"b6bce078","980":"deacae63"}[chunkId] + ".js";
};